<div
  class="pane-subheader theme-light d-flex"
  (click)="toggleOpen()"
  [ngClass]="{
    open: open,
    'mb-0': variant === 'dashboard' && open,
    'mb-2': variant === 'dashboard' && !open,
    'accordion-container-menu-page': variant === 'dashboard',
  }"
>
  <div class="header-subtitle">
    <h2>{{ title }}</h2>
  </div>
  <div class="subtitle-actions">
    <div
      class="header-background round-background container-theme-light-icons icon-button"
    >
      <i
        class="fa m-auto collapse-icon"
        [ngClass]="open ? 'fa-chevron-down' : 'fa-chevron-right'"
      ></i>
    </div>
  </div>
</div>
<div
  *ngIf="open"
  class="p-3"
  [ngClass]="{ 'border-expanded': variant === 'dashboard' }"
>
  <ng-content></ng-content>
</div>
